import { ApiConfig } from './api';
import { fetchWrapper, objectToSearchParams } from './utils/http-utils';
import { SpecType } from '../types/common';

type QueryType = {
  tags?: string[];
  without_tags?: boolean;
  exclude_tags?: string[];
};

export const userApi =
  (config: ApiConfig) =>
  (query: QueryType): Promise<SpecType> => {
    const searchParams = objectToSearchParams(query);
    const url = `${config.userapiendpoint}user-openapi.json${searchParams ? `?${searchParams}` : ''}`;

    return fetchWrapper<SpecType>(
      url,
      {
        method: 'GET',
      },
      config
    );
  };

export const helpItemEntry =
  (config: ApiConfig) =>
  (json: {
    label: string;
    document: string;
    content_path?: string;
    content_title?: string;
    reset?: boolean;
  }): Promise<{ url: string; edit_url: string }> =>
    fetchWrapper<{ url: string; edit_url: string }>(
      `${config.endpoint}help_item_docs`,
      {
        method: 'POST',
        body: JSON.stringify(json),
      },
      config
    );
